module.exports = __webpack_public_path__ + "static/media/duplicate.c8f4cd4c.svg";